<app-example-format
  [title]="componentInfo.title"
  urlTSDocs=""
  urlVoorbeelden=""
  urlChangelog=""
  [codeHtmlPath]="'code/examples/example-dataset-tree/example-dataset-tree-adv/example-dataset-tree-adv.component.html'"
  [codeTypescriptPath]="'code/examples/example-dataset-tree/example-dataset-tree-adv/example-dataset-tree-adv.component.ts'"
  [codeScssPath]="'code/examples/example-dataset-tree/example-dataset-tree.component.scss'"
  [kaartConfigFilePath]="'code/examples/example-dataset-tree/kaartconfig.json'"
  [treeConfigFilePath]="'code/examples/example-dataset-tree/treeconfig.json'"
  urlCodeHtml="example-dataset-tree/example-dataset-tree-adv/example-dataset-tree-adv.component.html"
  urlCodeTypescript="example-dataset-tree/example-dataset-tree-adv/example-dataset-tree-adv.component.ts"
  urlCodeScss="example-dataset-tree/example-dataset-tree.component.scss"
  urlKaartConfig="example-dataset-tree/kaartconfig.json"
  urlTreeConfig="example-dataset-tree/treeconfig.json"
>
  @if (componentInfo.tags && componentInfo.tags?.length > 0) {
    <div page-labels>
      @for (tag of componentInfo.tags; track tag) {
        <span class="badge bg-primary mx-1">{{ tag.toLocaleLowerCase() }}</span>
      }
    </div>
  }

  <div page-introduction>
    <p>
      {{ componentInfo.introduction }}
    </p>
  </div>

  <div page-functionality>
    <div class="row">
      <!-- DOCS:START functionality -->
      <div class="col-md-4 col-sm-6">
        <div>
          <label>
            <input type="checkbox" [(ngModel)]="hideTree" />
            Wissel de style van de dataset-tree (lijst of boom)
          </label>
        </div>
        <div>
          <label>
            <input type="checkbox" [(ngModel)]="showActiveCounters" />
            Zet actieve lagen teller aan of uit
          </label>
        </div>
        <div>
          <label>
            <input type="checkbox" [(ngModel)]="iconAlignRight" />
            Wijzig uitlijning van uit- inklap iconen
          </label>
        </div>
        <div>
          <label>
            <input type="checkbox" [(ngModel)]="showOnlyDatasets" />
            Verberg of toon hoogste niveau in de boom (theme)
          </label>
        </div>
        <br />
        <div class="dataset-tree-container">
          <ggc-dataset-tree
            [themes]="datasetTreeConfig"
            [mapIndex]="mapIndex"
            [expandTreeOnInit]="expandTreeOnInit"
            [hideTree]="hideTree"
            [showActiveCounters]="showActiveCounters"
            [iconAlignRight]="iconAlignRight"
            [showOnlyDatasets]="showOnlyDatasets"
            [iconExpanded]="iconExpanded"
            [iconCollapsed]="iconCollapsed"
            [iconUnchecked]="iconUnchecked"
            [iconChecked]="iconChecked"
            [iconInfoUrl]="iconInfoUrl"
          ></ggc-dataset-tree>
        </div>
      </div>
      <div class="col-md-6 col-sm-10">
        <div class="map-container">
          <ggc-map [webServices]="mapConfig" [mapIndex]="mapIndex"></ggc-map>
        </div>
        <p>Huidige resolutie: {{ resolution | number: "1.2-2" }}</p>
      </div>
      <!-- DOCS:END functionality -->
      <div class="col-md-1 col-sm-1">
        <div class="row options-toggle">
          <h6 id="extraOptionsLabel">Extra opties</h6>
          <label class="switch">
            <input
              type="checkbox"
              checked
              aria-labelledby="extraOptionsLabel"
              (change)="goToPage('/dataset-tree-basic')"
            />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</app-example-format>
